import { Box, Divider } from "@mui/material";
import { ReactNode } from "react";
import ElevatedPaper, {
  DEFAULT_STYLE,
} from "../../../components/ElevatedPaper";
import Flex from "../../../components/Flex";
import Text from "../../../components/Text";

type PatientSectionWrapperProps = {
  children: ReactNode;
  title?: string;
  header?: ReactNode;
  endAction?: ReactNode;
};

/**
 * @description User for layout in `PATIENT-PORTAL`
 *
 * @author [Rajkumar rathod]
 */
const PatientSectionWrapper = ({
  children,
  title,
  header,
  endAction,
}: PatientSectionWrapperProps) => {
  const hasHeader = title || header || endAction;

  return (
    <Box width={"100%"}>
      <ElevatedPaper sx={{ ...DEFAULT_STYLE, height: "100%" }}>
        <Flex width={"100%"} flexDirection={"column"} gap={1} height={"100%"}>
          {(hasHeader || title) && (
            <Box width={"100%"} py={0.5}>
              <Flex
                width={"100%"}
                maxHeight={"40px"}
                minHeight={"40px"}
                alignItems={"center"}
                height={"100%"}
                justifyContent={"space-between"}
              >
                {title && <Text ml={1}>{title}</Text>}
                {header && (
                  <Flex
                    alignItems={"center"}
                    height={"100%"}
                    width={"100%"}
                    flex={1}
                  >
                    {header}
                  </Flex>
                )}
                {endAction && (
                  <Flex height={"100%"} alignItems={"center"}>
                    {endAction}
                  </Flex>
                )}
              </Flex>
              <Divider
                sx={{ width: "100%", backgroundColor: "gray", mt: 0.5 }}
              />
            </Box>
          )}

          <Flex
            flex={1}
            width={"100%"}
            minWidth={0}
            sx={{ overflow: "hidden" }}
          >
            {children}
          </Flex>
        </Flex>
      </ElevatedPaper>
    </Box>
  );
};

export default PatientSectionWrapper;
